<style scoped>
    .confirm-message {
        text-align: center;
    }
</style>

<template>
<ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-dialog v-model="handleDialog" width="1200" class="common-dialog">
        <v-card color="#F4FEFB">
            <v-card-title class="justify-center text-h5">メンバー追加</v-card-title>
                <v-card-text
                    class="common-dialog-message"
                >
                <v-container>
                    <v-row>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="必　須" color="red">
                                <label-component>メールアドレス</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <ValidationProvider rules="required|email|max:100" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="email" :error-messages="errors" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="必　須" color="red">
                                <label-component>氏名</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <ValidationProvider rules="required|max:255" v-slot="{ errors }">
                                <v-text-field outlined clearable v-disabled-icon-focus v-model="name" background-color="white"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>管理者権限　　　　</label-component>
                            </badge-component>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        mdi-help-circle
                                    </v-icon>
                                </template>
                                <span>企業・請求情報の更新、グループメンバーやグループの設定、<br>メンバーが作成した書類の管理などを行えます</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="role"
                                inset
                                :label="role? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile color="unset">
                                <label-component>承認者　　　　　　</label-component>
                            </badge-component>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                        mdi-help-circle
                                    </v-icon>
                                </template>
                                <span>契約の承認者として選択できるようになります</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-switch
                                v-model="is_authorizer"
                                inset
                                :label="is_authorizer? '権限を付与する' : '' "
                            ></v-switch>
                        </v-col>
                        <v-col cols="12" xl="3">
                            <badge-component tile content="任　意">
                                <label-component>グループ</label-component>
                            </badge-component>
                        </v-col>
                        <v-col cols="12" xl="7">
                            <v-select
                                v-model="organization_id"
                                :items="organizations"
                                outlined
                                clearable
                                v-disabled-icon-focus
                                background-color="white"
                            ></v-select>
                        </v-col>
                        <!--グループを選択した場合、表示-->
                        <template v-if="group_flg">
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>グループ管理者権限</label-component>
                                </badge-component>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                        color="primary"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            mdi-help-circle
                                        </v-icon>
                                    </template>
                                    <span>グループメンバーやグループの設定などを行えます</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <v-switch
                                    v-model="team_administrator_privileges"
                                    inset
                                    :label="team_administrator_privileges? '権限を付与する' : '' "
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>書類管理者権限　　</label-component>
                                </badge-component>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                        color="primary"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            mdi-help-circle
                                        </v-icon>
                                    </template>
                                    <span>メンバーが作成した書類の管理を行えます</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <v-switch
                                    v-model="document_manager"
                                    inset
                                    :label="document_manager? '権限を付与する' : '' "
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xl="3">
                                <badge-component tile color="unset">
                                    <label-component>親展書類管理者　　</label-component>
                                </badge-component>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                        color="primary"
                                        dark
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            mdi-help-circle
                                        </v-icon>
                                    </template>
                                    <span>メンバーが作成した親展書類の管理を行えます</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <v-switch
                                    v-model="confidential_document_manager"
                                    inset
                                    :label="confidential_document_manager? '権限を付与する' : '' "
                                ></v-switch>
                            </v-col>
                        </template>
                    </v-row>
                </v-container>
            </v-card-text>
            
            <v-divider></v-divider>
            
            <v-card-actions class="justify-center grey lighten-4 pb-6">
                <v-btn min-width="150px" class="white--text" color="red" large v-on:click="invitation" :disabled="invalid">
                    <slot name="ok-btn"></slot>
                </v-btn>
                <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="handleDialog = false">
                    <slot name="cancel-btn"></slot>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</ValidationObserver>
</template>

<script>
export default {
    data() {
        return {
            // 組織＿ユーザの登録制御
            group_flg: false,
            // グループ
            organizations: [],
            email: '',
            name: '',
            role: false,
            organization_id: '',
            is_authorizer: false,
            team_administrator_privileges: false,
            document_manager: false,
            confidential_document_manager: false,
            show_message: false,
        };
    },
    props: {
        // ダイアログの開閉
        invitationDialog: Boolean,
    },
    computed: {
        handleDialog: {
            get() {
                return this.invitationDialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:invitationDialog', value);
            }
        },
    },
    methods: {
        invitation: function (event) {
            axios.post(
                '/documents/add-invitation',
                {
                    'email': this.email,
                    'username': this.name,
                    'role': this.role,
                    'organization_id': this.organization_id,
                    'is_authorizer': this.is_authorizer,
                    'team_administrator_privileges': this.team_administrator_privileges,
                    'document_manager': this.document_manager,
                    'confidential_document_manager': this.confidential_document_manager,
                }
            ).then(res => {
                // 親コンポーネントへの通知
                if (res.data.success) {
                    this.$emit("success", res.data.message);
                    this.handleDialog = false;
                } else {
                    this.$emit("error", res.data.message);
                }
            }).catch(res => {
              // console.log(res);
                this.success = false;
                this.message = "処理に失敗しました";
                this.$emit("error", "処理に失敗しました");
            }).finally(() => {
            });
        }
    },
    watch: {
        // グループ選択
        'organization_id': function(next, prev) {
            if (next) {
                this.group_flg = true;
            } else {
                this.group_flg = false;
            }
        }
    },
    // 初期表示のデータ
    mounted() {
        axios.get('/documents/get-invitation').then(res => {
            this.organizations = res.data.organizations;
        });
    },
};
</script>